import { ICON_SOURCES, UIIntegrationIconName } from '@futrli/ui-components';

export const ICON_NAMES = Object.keys(ICON_SOURCES) as readonly UIIntegrationIconName[];
